import { render } from "./HelpTicket.vue?vue&type=template&id=4ca7509e&ts=true"
import script from "./HelpTicket.vue?vue&type=script&lang=ts"
export * from "./HelpTicket.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__